import React from 'react';
import { ContextSelector, SelectedContextHeader } from '@klp/contextSelector';

import { Hidden } from '@material-ui/core';

type HeaderContextSelectorProps = {
    headerRef: React.RefObject<HTMLDivElement>;
};

export const HeaderContextSelector: React.FC<HeaderContextSelectorProps> = ({
    headerRef,
}) => {
    return (
        <>
            <ContextSelector listRef={headerRef} />
            <Hidden smDown={true}>
                <SelectedContextHeader />
            </Hidden>
        </>
    );
};
